import ListenerCoinChangesGraphCard from 'src/component/screen/listenercoinchangesgraph/ListenerCoinChangesGraphCard';

type Props = {
  liverId: number;
};

export function ListenerCoinChangesGraphScreen(props: Props): JSX.Element {
  return <ListenerCoinChangesGraphCard liverId={props.liverId} />;
}
